import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { t } from '../utils/i18n';
import { sendEvent } from '../utils/analytics';

export default function ConversionProofBlock({ language, context = 'landing', surfaceClassName = '' }) {
  const handleClick = () => {
    sendEvent('conversion_proof_click', {
      context,
      language: language === 'en' ? 'en' : 'es'
    });
  };

  return (
    <Card className={`conversion-proof-block ${surfaceClassName || 'border-0 shadow-sm'}`.trim()}>
      <Card.Body>
        <p className="fw-semibold mb-2">{t('conversionProof.title', language)}</p>
        <ul className="small text-muted mb-3">
          <li>{t('conversionProof.pointOne', language)}</li>
          <li>{t('conversionProof.pointTwo', language)}</li>
          <li>{t('conversionProof.pointThree', language)}</li>
        </ul>
        <div className="d-flex flex-wrap gap-2 mb-3">
          <span className="badge text-bg-light border">{t('conversionProof.badgeOne', language)}</span>
          <span className="badge text-bg-light border">{t('conversionProof.badgeTwo', language)}</span>
        </div>
        <Link to="/all-news" className="btn btn-outline-primary btn-sm" onClick={handleClick}>
          {t('conversionProof.cta', language)}
        </Link>
      </Card.Body>
    </Card>
  );
}
